import { useTranslation } from 'react-i18next'
import { Button } from '@chakra-ui/react'
import { FaEnvelope } from 'react-icons/fa'
import { colors } from '../../utilities/colors'

const CARPOOL_SUPPORT_EMAIL = 'support@carpoollogistics.com'

export default function CarpoolSupportButton() {
  const { t } = useTranslation()

  return (
    <Button
      as="a"
      href={`mailto:${CARPOOL_SUPPORT_EMAIL}`}
      variant="outline"
      bg="transparent"
      color={colors.grey100}
      borderColor={colors.grey100}
      borderWidth="1px"
      _hover={{ bg: colors.grey100, color: colors.grey900 }}
      h={{ base: '20px', lg: '22px' }}
      minH={{ base: '20px', lg: '22px' }}
      px={{ base: 2, lg: 3 }}
      borderRadius="full"
      fontSize={{ base: '2xs', lg: 'xs' }}
      fontWeight="semibold"
      lineHeight="1"
      data-testid="carpool-support-button"
    >
      <FaEnvelope />
      {t('Support')}
    </Button>
  )
}
